import script from "./entry-collapse.vue?vue&type=script&lang=js"
export * from "./entry-collapse.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/layouts/partials/sidebar/entry-collapse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b594950e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b594950e', __exports__)) {
    console.log('reload')
    api.reload('b594950e', __exports__)
  }
  
}


export default __exports__